<template>
  <div class="productCatalog">
    <div class="group-layout">
      <div class="group-layout-title f-source-han-serif-cn-M">
        {{ $t('productCatalog.title') }}
      </div>
      <div class="group-layout-sub-title f-source-han-sans-cn-L">
        {{ $t('productCatalog.subtitle') }}
      </div>
      <div class="group-layout-menulist flex-rowl f-source-han-serif-cn-M">
        <p
          v-for="(item, index) in menuList"
          :key="index"
          :class="{ active: item.value == menuValue }"
          @click="menuValue = item.value"
        >
          {{ $t(`productCatalog.${item.key}`) }}
        </p>
      </div>
      <div class="group-layout-list flex-rowl">
        <!-- 循环渲染产品列表 -->
        <template v-for="(product, index) in productList">
          <div
            :key="index"
            class="group-layout-item"
            @mouseenter="hoveredIndex = index"
            @mouseleave="hoveredIndex = -1"
            @click="handleGo(product.link)"
            v-if="product.type == menuValue || menuValue == 1"
          >
            <!-- 默认展示pic、tit -->
            <div v-if="hoveredIndex !== index" class="default-content">
              <img :src="product.pic" alt="product" />
              <div class="main-content">
                <p class="flex-rowc f-source-han-serif-cn-M">
                  {{ $t(`productCatalog.products.${product.key}.name`) }}
                </p>
              </div>
            </div>
            <!-- 鼠标移入之后展示pic1、txt -->
            <div v-else class="hover-content">
              <img :src="product.pic1" alt="product" />
              <div class="main-content">
                <p
                  class="f-source-han-serif-cn-M flex-rowl"
                  v-html="$t(`productCatalog.products.${product.key}.desc`)"
                ></p>
                <a class="flex-rowr"
                  ><i class="iconfont icon-detail"></i>{{ $t(`productCatalog.checkDetails`) }} </a
                >
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="join_wrap">
      <!-- <div class="img">
        <img :src="require('@/assets/images/join_bg.png')" alt="" />
      </div> -->
      <div class="content flex-colc wow animate__animated animate__slideInUp">
        <div class="title">
          <p class="txt1 f-times-new-roman">{{ $t('join.title1') }}</p>
          <p class="txt2 f-source-han-serif-cn-M">{{ $t('join.title2') }}</p>
          <p class="txt3 f-source-han-serif-cn-M">{{ $t('join.title3') }}</p>
        </div>
        <div class="txt">
          <p>{{ $t('join.desc1') }}</p>
          <p>{{ $t('join.desc2') }}</p>
        </div>
        <div class="more flex-rowc" @click="handleGo('ProductPage')">{{ $t('join.more') }}</div>
      </div>
    </div>
  </div>
</template>
      <script>
export default {
  name: "ProductCatalog",
  data() {
    return {
      menuValue: 1,
      menuList: [
        { value: 1, name: "所有產品", key: "allProducts" },
        { value: 2, name: "面膜", key: "masks"  },
        { value: 3, name: "彈力賦活系列", key: "essenceSeries" },
        { value: 4, name: "賦顏菁萃系列", key: "essenceSeries" },
      ],
      // 产品
      productList: [
        {
          key: 'softMoistFoundation',
          pic: "https://upload.vwingist.com/melscn/0image/2025/10/5549456103765524208.jpg?v=01",
          tit: "柔光水潤粉底液",
          pic1: "https://upload.vwingist.com/melscn/0image/2025/03/4767297683696240407.png",
          txt: "山茶籽油精粹,大自然的神奇力量<br/>肌膚的隱形守護者",
          link: "/ProductDetailPage/detail7",
          type: 3,
        },
        {
          key:'collagenMask',
          pic: "https://upload.vwingist.com/melscn/0image/2025/10/5744493551731885948.jpg?v=01",
          tit: "膠原蛋白蜜肌面膜",
          pic1: "https://upload.vwingist.com/melscn/0image/2025/03/5030991517304987221.png",
          txt: "給肌膚的瑞士甜蜜假期<br/>一次20分鐘瑞士之旅，让肌膚煥然一新！",
          link: "/ProductDetailPage/detail1",
          type: 2,
        },
        {
          key:'blackDiamondMask',
          pic: "https://upload.vwingist.com/melscn/0image/2025/10/5738893836156167536.jpg?v=01",
          tit: "黑鑽至臻炭煥顏面膜",
          pic1: "https://upload.vwingist.com/melscn/0image/2025/03/4748409368144628421.png",
          txt: "備長炭的神奇力量<br/>黑鑽魔力，喚醒沉睡美肌",
          link: "/ProductDetailPage/detail2",
          type: 2,
        },
        {
          key:'resilienceWater',
          pic: "https://upload.vwingist.com/melscn/0image/2025/10/4774333526635990735.jpg?v=01",
          tit: "彈力賦活精華水",
          pic1: "https://upload.vwingist.com/melscn/0image/2025/03/4819987290030159721.png",
          txt: "开启糖化狙击战",
          link: "/ProductDetailPage/detail3",
          type: 3,
        },
        {
          key:'resilienceSerum',
          pic: "https://upload.vwingist.com/melscn/0image/2025/10/5120113416201887707.jpg?v=01",
          tit: "彈力賦活抗皺精華液",
          pic1: "https://upload.vwingist.com/melscn/0image/2025/03/5326980082015258142.png",
          txt: "深層滲透，彈性活化<br/>抗氧+抗糖雙重功效",
          link: "/ProductDetailPage/detail4",
          type: 3,
        },
        {
          key:'resilienceCream',
          pic: "https://upload.vwingist.com/melscn/0image/2025/10/5435525302670567608.jpg?v=01",
          tit: "彈力賦活抗皺精華霜",
          pic1: "https://upload.vwingist.com/melscn/0image/2025/03/5695447372269616484.png",
          txt: "定格裸感美肌<br/>鎖鮮防護，持久保濕",
          link: "/ProductDetailPage/detail5",
          type: 4,
        },
        {
          key:'rejuvenatingOil',
          pic: "https://upload.vwingist.com/melscn/0image/2025/04/4990238919937414802.jpg",
          tit: "賦顏菁萃精華油",
          pic1: "https://upload.vwingist.com/melscn/0image/2025/03/5005000592352847393.png",
          txt: "肌膚的天然「保護膜」－角鯊烷<br/>抵禦外界的侵襲，鎖住青春",
          link: "/ProductDetailPage/detail6",
          type: 4,
        },
      ],
      hoveredIndex: -1, // 用于记录当前鼠标悬停的产品索引
    };
  },
  mounted() {
    console.log(this.$route, "---");
    // 初始化时根据路由参数设置menuValue
    if (this.$route.query.catalogType) {
      this.menuValue = this.$route.query.catalogType;
    }
  },
  watch: {
    // 监听 $route 对象的变化
    "$route.query.catalogType": {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // 当 catalogType 参数值发生变化时更新 menuValue
          this.menuValue = newVal;
        }
      },
      immediate: false // 不立即执行 handler
    }
  },
  methods: {
    handleGo(link) {
      this.$router.push(link);
    },
  },
};
</script>
    <style lang="less">
.productCatalog {
  padding-top: 145px;
  box-sizing: border-box;
  .image-container {
    display: inline-block; /* 确保容器只占用图片的空间 */
    overflow: hidden; /* 隐藏超出容器的部分 */
  }
  .zoomable-image {
    transition: transform 0.3s ease; /* 添加过渡效果，使放大过程更平滑 */
    cursor: pointer;
    &:hover {
      transform: scale(1.07); /* 鼠标悬停时放大图片 */
    }
  }
  .group-layout {
    width: 1340px;
    margin: auto;
    color: #000000;
    .group-layout-title {
      font-size: 36px;
    }
    .group-layout-sub-title {
      font-size: 24px;
      margin: 20px 0 50px;
    }
    .group-layout-menulist {
      margin-bottom: 60px;
      p {
        font-size: 24px;
        color: #917e6d;
        margin-right: 70px;
        position: relative;
        cursor: pointer;
        &.active {
          color: #000000;
          font-weight: bold;
          &::after {
            display: inline-block;
            content: "";
            width: 100%;
            height: 3px;
            background: #000000;
            left: 0;
            right: 0;
            bottom: -15px;
            position: absolute;
          }
        }
      }
    }
    .group-layout-list {
      align-items: flex-start;
      flex-wrap: wrap;
      .group-layout-item {
        width: 406px;
        height: 578px;
        position: relative;
        cursor: pointer;
        margin-right: 61px;
        margin-bottom: 60px;
        overflow: hidden;
        cursor: pointer;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .hover-content {
          .main-content {
            p {
              font-size: 20px;
              //   min-height: 99px;
              height: auto;
              padding: 20px 30px;
              box-sizing: border-box;
              line-height: 26px;
              margin-bottom: 2px;
            }
            a {
              width: 100%;
              height: 50px;
              font-size: 16px;
              color: #fff;
              padding: 0 20px;
              box-sizing: border-box;
              background: rgba(0, 0, 0, 0.6);
              .iconfont {
                font-size: 14px;
                margin-right: 5px;
              }
            }
          }
        }
        .main-content {
          position: absolute;
          bottom: 20px;
          left: 20px;
          right: 20px;
          p {
            width: 100%;
            background: rgba(0, 0, 0, 0.6);
            font-size: 24px;
            color: #fff;
            height: 65px;
          }
        }
      }
    }
  }
  .join_wrap {
    position: relative;
    margin: 100px 0 127px;
    background: url("https://upload.vwingist.com/melscn/0image/2025/04/5175367247852106837.png")
      no-repeat center;
    background-size: cover;
    width: 100%;
    height: 750px;
    padding: 120px 0 0 279px;
    box-sizing: border-box;
    .content {
      width: 695px;
      align-items: flex-start;
      .title {
        color: #000000;
        .txt1 {
          font-size: 60px;
        }
        .txt2 {
          font-size: 36px;
          margin: 5px 0;
        }
        .txt3 {
          font-size: 50px;
        }
      }
      .txt {
        margin: 50px 0 40px;
        font-size: 20px;
        p {
          line-height: 27px;
          &:last-child {
            margin-top: 10px;
          }
        }
      }
      .more {
        font-size: 20px;
        text-align: center;
        line-height: 50px;
        height: 50px;
        background: #e9e9e9;
        font-size: 20px;
        cursor: pointer;
        padding: 0 30px;
        box-sizing: border-box;
        &:hover {
          background: #333333;
          color: #fff;
        }
      }
    }
  }
}
</style>